import axios, { AxiosRequestConfig } from 'axios';
import { getUserToken } from '../AuthService';
import { ITgUser } from '../../types';

export function getHeaders() {
  const tgUserLs = window.localStorage.getItem('tgUser');

  if (!tgUserLs) {
    return {};
  }

  const tgUser: ITgUser = JSON.parse(tgUserLs);
  return {
    [`Authorization`]: `Bearer ${tgUser.hash}`,
    [`x-user-id`]: `${tgUser.id}`,
  } as AxiosRequestConfig;
}
